import { ISelectData } from '../ui/Selects/select/model'

export const extractValues = (element: ISelectData[]): number[] => {
  return element.map(item => item.value)
}
